import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RuleTileComponent } from './components/rule-tile.component';
import { MaterialModule } from '../material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { StoreModule } from '@ngrx/store';
import { ModuleConfiguration } from './business-rule.module.config';
import { reducers } from './store/reducers/';
import { EffectsModule } from '@ngrx/effects';
import { RuleServiceEffects } from './services/RuleService.effects';
import { RouterModule } from '@angular/router';
import { ruleRoutes } from './routes.config';
import { PillarModule } from '../pillar/pillar.module'
import { RuleService } from './services/RuleService';
import { ParameterService } from './services/ParameterService';
import { ParameterServiceEffects } from './services/ParameterService.effects';
import { DashboardTilesRegistry } from '../pillar/dashboard/services/DashboardTilesRegistry';
import { RuleCollectionDashboardComponent } from './components/rule-collection-dashboard.component';
import { RuleCollectionTileComponent } from './components/rule-collection-tile.component';
import { ConfigurationDashboardComponent } from '../configuration/components/configuration-dashboard.component';
import { CoreModule } from '../core/core.module';
import { RuleWorkspaceComponent } from './components/rule-workspace.component';
import { EditParameterComponent } from "./components/edit-parameter.component";
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';

@NgModule({
  entryComponents: [RuleTileComponent, EditParameterComponent],
  declarations: [RuleTileComponent, RuleCollectionDashboardComponent, RuleCollectionTileComponent, RuleWorkspaceComponent, EditParameterComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([RuleServiceEffects, ParameterServiceEffects]),
    RouterModule.forChild(ruleRoutes),
    ReactiveFormsModule,
    PillarModule,
    CoreModule,
    MatDatepickerModule,
    MatNativeDateModule 
  ],
  exports: [],
  providers: [RuleService, ParameterService, MatDatepickerModule]
})
export class BusinessRuleModule {
  constructor(private dashboardTilesRegistry: DashboardTilesRegistry) {
    dashboardTilesRegistry.registerTile(ConfigurationDashboardComponent.dashboardName,
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 2,
        tileComponent: RuleTileComponent,
        permission: "RuleModule.BusinessRule:View",
        displayName: "Rules"
      });

    dashboardTilesRegistry.registerTile('rule-collection',
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 1,
        tileComponent: RuleCollectionTileComponent,
        permission: "RuleModule.BusinessRule:View",
        displayName: "Rules"
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/business-rule.module.ts